import p5 from 'p5';
import { memo, useEffect, useState } from 'react';

const options = ['A', 'T', 'C', 'G'];
const maxOpacity = 0.2;

type Char = {
  char: string;
  opacity: number;
  direction: number;
};

export const DNA = memo(() => {
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef) return () => {};
    const bounds = containerRef.getBoundingClientRect();
    const { width, height } = bounds;
    const speed = 0.01 * (width / 1000);
    function getRequiredChars(width: number, height: number, charSize: number) {
      const charsPerLine = Math.floor(width / charSize);
      const lines = Math.floor(height / charSize);
      return charsPerLine * lines;
    }

    function createCharArray(width: number, height: number, charSize: number) {
      const requiredChars = getRequiredChars(width, height, charSize);
      const chars: Char[] = [];
      for (let i = 0; i < requiredChars; i++) {
        const char = options[
          Math.floor(Math.random() * options.length)
        ] as string;
        const direction = 1;
        let opacity = Math.random() * maxOpacity - Math.random() * maxOpacity;
        chars.push({ char, opacity, direction });
      }
      return chars;
    }

    function sketch(p: p5 & { chars: Char[]; container: HTMLElement }) {
      p.setup = () => {
        p.textSize(12);
        p.createCanvas(width, height);
        p.container = containerRef as HTMLElement;
        const chars = createCharArray(width, height, 12);
        p.chars = chars;
      };

      p.draw = () => {
        const dark = document.querySelector('body')?.classList.contains('dark');
        const textColor = dark ? 255 : 0;
        p.clear(0, 0, 0, 0);
        p.background('rgba(255,255,255, 0)');
        let x = 0;
        let y = 0;
        const chars = p.chars;
        const charWidth = p.textWidth('A');
        const charHeight = 20;
        chars.forEach((char) => {
          // for (let i = 0; i < chars.length; i++) {
          // const { char, opacity } = chars[i];
          // p.fill(228, 64, 123, opacity * 255);
          p.fill(textColor, char.opacity * 255);
          p.text(char.char, x, y);
          x += charWidth;
          if (x > width) {
            x = 0;
            y += charHeight;
          }
          char.opacity += char.direction * speed;
          if (char.opacity > maxOpacity && char.direction === 1) {
            char.opacity = maxOpacity;
            char.direction = -1;
          }
          if (char.opacity < 0 && char.direction === -1) {
            char.opacity = 0;
            char.direction = 1;
          }
        });
      };
      p.windowResized = () => {
        const newWidth = containerRef?.clientWidth || 0;
        const newHeight = containerRef?.clientHeight || 0;
        p.resizeCanvas(newWidth, newHeight);
      };
    }
    const instance = new p5(sketch, containerRef);

    return () => {
      instance.noLoop();
      instance.remove();
    };
  });

  return (
    <div
      ref={setContainerRef}
      className="w-screen h-screen dark:bg-neutral-800"
    />
  );
});
